module.exports = __webpack_public_path__ + "523ce45db96eebd3a03f57cfd6cfc182.png";